import React, { useState, useEffect } from 'react';
import '../../css/onboardingReferalSteps.css';
import Header from '../../components/Header';
import Footer from '../../components/Footer';
import { useNavigate } from 'react-router-dom';
import { useMobileMediaQuery, useTabletMediaQuery } from '../../utils';
import CustomButton from '../../components/CustomButton';
import GifAnim from '../../components/GifAnim';
import imgStepTwo from '../../assets/img/onboarding/desktop/img-carteira-ja-esta-ativa.jpg';
import imgStepTwoTablet from '../../assets/img/onboarding/tablet/img-carteira-ja-esta-ativa.jpg';
import imgStepTwoMobile from '../../assets/img/onboarding/mobile/img-carteira-ja-esta-ativa.jpg';

function OnboardingReferalStepTwo() {

    const [isLoading, setIsLoading] = useState(true);
    const navigate = useNavigate();
    const isMobile = useMobileMediaQuery();
    const isTablet = useTabletMediaQuery();

    useEffect(() => {
        const delay = setTimeout(() => {
        setIsLoading(false); 
        }, 1000); 

        return () => clearTimeout(delay); 
    }, []);

    const hadleBtnClickAddLater = () => {
        navigate('/');
    };

    const hadleBtnClickAddNow = () => {
        navigate('/ativar-carteira-virtual/associar-cartao/tipo-de-associacao');
    };

  return ( 
    <>
    <Header/> 
    { !isTablet && 
        <>
            <div className='mainBgViewContainerReferalStepsMobileTablet'></div>
        </>
    }
    { isLoading ? 
        <GifAnim />
    :
    <div className={ isTablet ? 'mainViewContainerReferalSteps' : ( isMobile ? 'mainViewContainerReferalStepsTablet' : 'mainViewContainerReferalStepsMobile')}>
        { !isTablet && 
            <>
            <div className={ isMobile ? 'mainImgViewReferalStepsTablet' : 'mainImgViewReferalStepsMobile' }>
                <img src={ isTablet ? imgStepTwo : ( isMobile ? imgStepTwoTablet : imgStepTwoMobile) } alt="imagem" className={ isMobile ?  "mainImgReferalStackTablet" : "mainImgReferalStackMobile" }/>
            </div>
            </>
        }
        <div className={  isTablet ? 'firstTxtViewContainerReferalSteps' : ( isMobile ? 'firstTxtViewContainerReferalStepsTablet' : 'firstTxtViewContainerReferalStepsMobile') }>
            <div className='firstTitleViewReferalSteps'>
                <div className={  isTablet ? 'textTitlePart1ReferalSteps' : ( isMobile ? 'textTitlePart1ReferalStepsTablet' : 'textTitlePart1ReferalStepsMobile') }>Sucesso!</div>
                <span className={  isTablet ? 'textTitlePart1ReferalSteps' : ( isMobile ? 'textTitlePart1ReferalStepsTablet' : 'textTitlePart1ReferalStepsMobile') }>A sua </span>
                <span className={  isTablet ? 'textTitlePart2ReferalSteps' : ( isMobile ? 'textTitlePart2ReferalStepsTablet' : 'textTitlePart2ReferalStepsMobile') }>Carteira Virtual já está ativa.</span>   
            </div>
            <div className={ isTablet ? 'secondTitleViewReferalSteps' : ( isMobile ? 'secondTitleViewReferalStepsTablet' : 'secondTitleViewReferalStepsMobile') }>Associe agora o seu cartão bancário e comece já a acumular saldo.</div>
            <div className={ isTablet ? 'btnsViewReferalSteps' : ( isMobile ? 'btnsViewReferalStepsTablet' : 'btnsViewReferalStepsMobile' )}>
                <div className={ isTablet ? 'divBtnSaltarReferalSteps' : ( isMobile ? 'divBtnSaltarReferalStepsStackTablet' : 'divBtnSaltarReferalStepsMobile' )}>
                    <CustomButton 
                        text={'Associar mais tarde'} 
                        textColor={'#00214D'}
                        onPress={hadleBtnClickAddLater} 
                        fontSize={'14px'}
                        hasSubLine
                        hasSubLineSmall
                        hasSubLineSmallColor={'#00214D'}
                    />
                </div> 
                <div className={ isTablet ? 'divBtnNextReferalSteps' : ( isMobile ? 'divBtnSaltarReferalStepsStackTablet' : 'divBtnNextReferalStepsMobile' )}>
                    <CustomButton 
                        text={'Associar cartão'} 
                        textColor={'#00214D'}
                        onPress={hadleBtnClickAddNow} 
                        color={'#15D4B6'}
                        hasArrow
                        iconColor={'#00214D'}
                    />
                </div>    
            </div>   
        </div>
        { isTablet && 
        <>
        <div className='subFirstImgViewContainerReferalSteps'>
            <div className='firstImgViewContainerReferalSteps'>
                <div className='mainImgViewReferalSteps'>
                    <img src={ isTablet ? imgStepTwo : ( isMobile ? imgStepTwoTablet : imgStepTwoMobile) } alt="imagem" className="mainImgReferalSteps" />
                </div>
            </div>
        </div>
        </>
        }
    </div>
    }
    <Footer/> 
    </>
  )
}

export default OnboardingReferalStepTwo;